<template>
  <div class="progress-bar">
    <v-progress-circular
      :color="progressBarData.color"
      :model-value="progressBarData.percentage"
      :rotate="360"
      :size="size"
      :width="width"
    >
      <h2 class="progress-bar__percentage">{{ progressBarData.percentage }}%</h2>
    </v-progress-circular>

    <div v-if="progressBarData.title"
         class="progress-bar__title">
      {{ progressBarData.title }}
    </div>

    <slot name="content"/>
  </div>
</template>

<script>
  export default {
    name: 'CircleProgressBar',
    props: {
      progressBarData: {
        type: Object,
        required: true,
      },
      size: {
        type: Number,
        default: 100,
      },
      width: {
        type: Number,
        default: 10,
      },
    },
  };
</script>

<style lang="scss" scoped>
.progress-bar {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: calc(100% / 3);
  position: relative;

  @include responsive(max, 991px) {
    width: 100%;
    padding-bottom: 16px;
  }

  &__percentage {
    color: var(--color-base-900);
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 1;
  }

  &__title {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    color: var(--gray500);
  }
}

:root[data-theme='dark'] {
  .progress-bar__percentage {
    color: var(--shadesBlack);
  }
}
</style>
